import { render, staticRenderFns } from "./customer-orders.vue?vue&type=template&id=088a79cc&scoped=true"
import script from "./customer-orders.vue?vue&type=script&lang=js"
export * from "./customer-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a79cc",
  null
  
)

export default component.exports